export default {
  "items": [
    {
      "name": "Tony Zhou",
      "from": "Tecent",
      "position": "Core Founder, Former CTO",
      "brief": "Valued at $346 billions as of June, 2017. Holding company for WeChat and QQ.",
      "pic": "whoareat-01.jpg"
    },
    {
      "name": "Wanqiang Li",
      "from": "Xiaomi",
      "position": "Co-founder",
      "brief": "One of China’s most well-known smart device makers.",
      "pic": "whoareat-02.jpg"
    },
    {
      "name": "Hongyi Zhou",
      "from": "360",
      "position": "Chairman",
      "brief": "A powerful antivirus giant that prevents millions of users from malware attacks.",
      "pic": "whoareat-03.jpg"
    },
    {
      "name": "Weiwei Hu",
      "from": "Mobike",
      "position": "Founder & CEO",
      "brief": "One of the world’s largest bicycle network which raised $600 million in series E funding.",
      "pic": "whoareat-04.jpg"
    },
    {
      "name": "Sheng Fu",
      "from": "Cheetah Mobile",
      "position": "CEO",
      "brief": "Internet security software provider. Products include Clean Master, CM Security and Battery Doctor.",
      "pic": "whoareat-05.jpg"
    },
    {
      "name": "Xiaochuan Wang",
      "from": "Sogou",
      "position": "CEO",
      "brief": "Boosted by AI & product differentiation, Sogou Search now firmly situates in No.2 market position in China.",
      "pic": "whoareat-06.jpg"
    },
    {
      "name": "Danian Chen",
      "from": "wifi.com",
      "position": "Founder",
      "brief": "",
      "pic": "whoareat-07.jpg"
    },
    {
      "name": "Kai Yu",
      "from": "Horizon Robotics",
      "position": "Founder & CEO",
      "brief": "",
      "pic": "whoareat-08.jpg"
    },
    {
      "name": "Hang Zhou",
      "from": "Founder of Yidao",
      "position": "Partner of Shunwei Capital",
      "brief": "",
      "pic": "whoareat-09.jpg"
    },
    {
      "name": "Wang Huang",
      "from": "Huami",
      "position": "Founder & CEO",
      "brief": "",
      "pic": "whoareat-10.jpg"
    },
    {
      "name": "Yuan Zhou",
      "from": "Zhihu",
      "position": "Founder & CEO",
      "brief": "",
      "pic": "whoareat-11.jpg"
    },
    {
      "name": "Zhifei Li",
      "from": "MobVoi",
      "position": "Founder & CEO",
      "brief": "",
      "pic": "whoareat-12.jpg"
    }
  ]
}



// WEBPACK FOOTER //
// ./src/mock/whoareat.js